import { render, staticRenderFns } from "./BreadcrumbContainer.vue?vue&type=template&id=6b6096b5&"
import script from "./BreadcrumbContainer.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6096b5')) {
      api.createRecord('6b6096b5', component.options)
    } else {
      api.reload('6b6096b5', component.options)
    }
    module.hot.accept("./BreadcrumbContainer.vue?vue&type=template&id=6b6096b5&", function () {
      api.rerender('6b6096b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/components/BreadcrumbContainer.vue"
export default component.exports